import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { APIProvider } from '@vis.gl/react-google-maps'
import GoogleMapContainer from '../common/components/GoogleMapContainer'

const googleMapsApiKey = 'AIzaSyCaMtih5UqeAP7MAGclyi2xGaPLIhFc9QA'

const toCoordinate = value => {
	if (value === '' || value == null) return null
	const parsed = Number(value)
	return Number.isFinite(parsed) ? parsed : null
}

export default function TrainingLocationMap({ training }) {
	const { t } = useTranslation()
	const g_lat = useMemo(() => toCoordinate(training?.g_lat), [training?.g_lat])
	const g_long = useMemo(() => toCoordinate(training?.g_long), [training?.g_long])

	return (
		<div className="rounded-md border border-gray-200 bg-white px-5 py-4 shadow-sm">
			<h2 className="text-sm font-semibold text-gray-900">{t('trainings.details.sections.map')}</h2>

			<div className="mt-4">
				{g_lat != null && g_long != null && googleMapsApiKey ? (
					<div className="overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
						<APIProvider apiKey={googleMapsApiKey} version="beta" libraries={['places', 'marker']}>
							<GoogleMapContainer
								g_placeid={training?.g_placeid}
								g_lat={g_lat}
								g_long={g_long}
								readOnly
							/>
						</APIProvider>
					</div>
				) : (
					<span className="text-sm text-gray-500">{t('trainings.details.emptyLocationMap')}</span>
				)}
			</div>
		</div>
	)
}
